import { render } from "./LoadingSpinner.vue?vue&type=template&id=f07db3c6&scoped=true"
const script = {}

import "./LoadingSpinner.vue?vue&type=style&index=0&id=f07db3c6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f07db3c6"

export default script